<div class="card-answer">
	<form [formGroup]="form">
		<ng-container formArrayName="answers">
			<ng-container
				*ngFor="let formAnswer of formAnswers.controls; let i = index; trackBy: trackByFn">
				<div [formGroupName]="i">
					<div class="box">
						<i
							class="fas fa-times-circle fa-lg icon-remove pointer"
							*ngIf="!_disabled"
							(click)="confirmDeletionAnswer(i, formAnswer.value, $event)"></i>

            <!-- Description -->
						<div class="wrapper-form-control">
							<label class="form-label d-block"> Respuesta </label>
							<textarea
								class="form-control"
								rows="2"
								formControlName="description"
								[ngClass]="{ 'is-invalid': hasError(i, 'answers', 'description') }">
							</textarea>

							<div class="invalid" *ngIf="hasError(i, 'answers', 'description')">
								{{ getFirstErrorMessage(i, 'answers', 'description') }}
							</div>
						</div>

            <!-- RelationDescription -->
						<div class="wrapper-form-control">
							<label class="form-label d-block"> Relación</label>
							<textarea
								class="form-control"
								rows="2"
								formControlName="relationDescription"
								[ngClass]="{ 'is-invalid': hasError(i, 'answers', 'relationDescription') }">
							</textarea>
							<div class="invalid" *ngIf="hasError(i, 'answers', 'relationDescription')">
								{{ getFirstErrorMessage(i, 'answers', 'relationDescription') }}
							</div>
						</div>
					</div>
				</div>
			</ng-container>
		</ng-container>
	</form>
</div>

<div>
	<hr />
	<button
		class="btn btn-primary btn-lg pointer"
		(click)="addNewAnswer()"
		[disabled]="_disabled">
		<i class="fal fa-plus"></i>
	</button>
</div>
